module.exports = __webpack_public_path__ + "img/wave.17015e13.svg";